import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MyProfile from "../common/MyProfile";
import { getAllOrderHistory } from "../apis/Api";
import { Link } from "react-router-dom";
import { Loader } from "../common/Loader";

const OrderPage = () => {
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const ordersPerPage = 1;
  const totalPages = Math.ceil(orders.length / ordersPerPage);

  const fetchOrderHistory = async () => {
    setLoading(true);
    try {
      const user_token = localStorage.getItem("token");
      if (!user_token) {
        return;
      }
      const response = await getAllOrderHistory({ cust_token: user_token });

      if (response) {
        setOrders(response.orderData);
      }
    } catch (error) {
      console.log("error getting Order data", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderHistory();
  }, []);

  // Pagination logic
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);

  if (loading) {
    return (
      <>
        <Header />
        <div className="container">
          <div className="row">
            <div
              className="col-md-12 d-flex justify-content-center flex-column align-items-center"
              style={{ minHeight: "80vh", backgroundColor: "white" }}
            >
              <Loader />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <div>
      <Header />
      <div id="content" className="no-top no-bottom">
        <div
          className="container removetopspace "
          style={{ paddingTop: "170px" }}
        >
          <div className="row">
            <MyProfile />

            <div className="col-md-7">
              {currentOrders.length > 0 ? (
                currentOrders.map((data, index) => {
                  const parsedProducts = data.products
                    ? JSON.parse(data.products)
                    : [];

                  return (
                    <div
                      key={index}
                      className="order-item card p-3 shadow-sm mb-3"
                      style={{ borderRadius: "10px" }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fw-bold" style={{ color: "#73b734" }}>
                          ✔ Order {data.order_id}
                        </span>
                        <button
                          className="btn btn-sm"
                          style={{
                            backgroundColor: "#73b734",
                            color: "#fff",
                            borderRadius: "8px",
                            height: "30px",
                            width: "70px",
                          }}
                        >
                          REPAIR
                        </button>
                      </div>
                      <small className="text-muted">{data.create_date}</small>
                      <div className="d-flex mt-3">
                        <img
                          src={parsedProducts[0].phone_url}
                          alt={parsedProducts[0].phone}
                          className="me-3"
                          style={{ borderRadius: "8px", height: "120px" }}
                        />
                        <div>
                          <h5 className="mb-1">
                            {parsedProducts[0].phone}
                            {/* <small className="text-muted">
                              {" "}
                              {parsedProducts[0].color_name}
                            </small> */}
                            <small className="text-muted">
                              {" "}
                              Genuine
                            </small>

                          </h5>
                          <p className="mb-1 text-wrap">
                            Booked Repair Services:{" "}
                            <strong>{parsedProducts[0].product}</strong>
                          </p>
                          <p className="mb-1 text-wrap">
                            Quantity:{" "}
                            <strong>{parsedProducts[0].quantity}</strong> |
                            Price:{" "}
                            <strong>₹{parsedProducts[0].payable_price}</strong>
                          </p>
                          <Link
                            to={`/order-details/${data.order_token}`}
                            className="text-primary"
                          >
                            View order details
                          </Link>
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between">
                        <span>Repair Amount</span>
                        <span className="fw-bold">
                          ₹{data.total_price || 0}
                        </span>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>No orders found.</p>
              )}

              {/* Pagination Controls */}
              {orders.length > ordersPerPage && (
                <div className="pagination mt-4 d-flex justify-content-center">
                  <button
                    style={{ height: "35px", width: "90px" }}
                    className="btn btn-primary me-2"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    Previous
                  </button>
                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    style={{ height: "35px", width: "70px" }}
                    className="btn btn-primary ms-2"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <br />
      <Footer />
    </div>
  );
};

export default OrderPage;
